import type { FieldOperations } from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/issuetypes/id/types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { PriorityFieldConfiguration } from './view';

export const isExpandable = (operations: FieldOperations): boolean =>
	operations.canModifyDefaultValue;
